/**
 * Calculate the start and end offsets for each text node in a block
 */
export function calculateLineOffsets(lines: Array<{ raw: string }>) {
    const lineOffsets = new Map<number, [number, number]>();
    let currentOffset = 0;
    for (const line of lines) {
        const lineLength = line.raw.length;
        const index = lines.indexOf(line);
        lineOffsets.set(index, [currentOffset, currentOffset + lineLength]);
        currentOffset += lineLength;
    }
    return lineOffsets;
}

/**
 * Find the index of the line matching a text offset
 **/
export function lookupLineForOffset(
    offset: number,
    lineOffsets: Map<number, [number, number]>
): number {
    let lineIndex = 0;
    for (const [lineStart, lineEnd] of lineOffsets.values()) {
        if (lineStart <= offset && offset < lineEnd) {
            return lineIndex;
        }
        ++lineIndex;
    }
    throw new Error(`Offset ${offset} is out of bounds`);
}
